import React from "react";
import AadhaarDigilocker from "../../../Components/AadhaarDigilocker";


// Same DigiLocker flow as the customer app: the widget opens on this page and the Aadhaar
// data is fetched as soon as the customer completes it (see Components/AadhaarDigilocker).
const AadhaarStage = ({ customerDetails, onVerified }) => {

    const customerId = customerDetails?.customerId;
    return (
        <AadhaarDigilocker
            initialAadhaarNo={customerDetails?.kyc?.aadhaar?.aadhaarNo}
            status={customerDetails?.kycStatus?.aadhaar?.status || customerDetails?.kyc?.aadhaar?.status}
            linkUrl={`/admin/customer/${customerId}/kyc/aadhaar/link`}
            verifyUrl={`/admin/customer/${customerId}/kyc/aadhaar/verify`}
            
            onVerified={onVerified}
        />
    );
};

export default AadhaarStage;
